module.exports = __webpack_public_path__ + "media/assets/icons/link-d110a88a2aa4e102f3daa104cafb6aa1.svg";